/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSimulateResponseFromDiscriminatorValue, serializeSimulateRequest, serializeSimulateResponse, type ErrorResponse, type InternalErrorResponse, type SimulateRequest, type SimulateResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/simulate
 */
export interface SimulateRequestBuilder extends BaseRequestBuilder<SimulateRequestBuilder> {
    /**
     * Runs the evaluator against a real cart and the organization's active campaigns, exactly as every cart change does, and returns the cart as it would look plus the plan: what applied and every campaign, promotion or code that did not, with its reason. Nothing is saved. Pass a code to try it on the cart without applying it. Pass a campaignId to evaluate that campaign as if it were active, so it can be tested before it goes live.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SimulateResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SimulateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SimulateResponse | undefined>;
    /**
     * Runs the evaluator against a real cart and the organization's active campaigns, exactly as every cart change does, and returns the cart as it would look plus the plan: what applied and every campaign, promotion or code that did not, with its reason. Nothing is saved. Pass a code to try it on the cart without applying it. Pass a campaignId to evaluate that campaign as if it were active, so it can be tested before it goes live.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SimulateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SimulateRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/simulate";
/**
 * Metadata for all the requests in the request builder.
 */
export const SimulateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SimulateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSimulateResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSimulateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
